import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {resetPremiumUpsellPanel} from '@Components/panels/premium-upsell-panel/premium-upsell-panel-reducer';

export const openPremiumUpsellModal = (featureName: string, onDialogLoaded?: () => void, shouldOpenInNewTab = false): void => {
  // Reset before the panel mounts so a prior failure/other-feature's state can't leak into this open
  // (stale hasFailed would self-close the modal; stale data would flash the previous feature's copy).
  window.PMW.redux.store.dispatch(resetPremiumUpsellPanel());
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.PREMIUM_UPSELL_MODAL,
      panelProps: {
        modalId: MODALS_IDS.PREMIUM_UPSELL_MODAL,
        featureName,
        shouldOpenInNewTab,
      },
    })
  );

  if (typeof onDialogLoaded === 'function') {
    onDialogLoaded();
  }
};
